<section class="step-nav">
  <div class="container-fluid w-limit">
    <div class="row mb-3 mb-md-4 g-2 g-md-1">
      <div class="col-6 col-lg me-auto col-md-3 order-md-0">
        <div
          class="select_view bg-white rounded-pill step-card hstack shadow-sm overflow-hidden d-flex align-items-center gap-1">
          <div
            class="check-select bg-primary px-2 h-100 text-white d-flex align-items-center align-content-center rounded-3 justify-content-center"
            style="min-height: 58px;">
            <app-icon name="circle-check" [size]="26" [strokeWidth]="2.5"></app-icon>
          </div>
          <div class="body-select small lh-sm px-2 pe-3">
            <small class="text-muted text-uppercase fw-bold">Elegiste</small>
            <h2 class="small fw-bold text-primary text-uppercase mb-0">{{
              selectedCategoryLabel }}</h2>
          </div>
        </div>
      </div>
      <div class="col-6 col-lg col-md-3 order-md-2">
        <div
          class="document-numb bg-white step-card ms-auto rounded-pill hstack shadow-sm overflow-hidden d-flex align-items-center gap-0">
          <div
            class="check-select bg-white px-3 h-100 text-primary d-flex align-items-center align-content-center rounded-3 justify-content-center"
            style="min-height: 58px;">
            <app-icon name="book-open-text" [size]="26" [strokeWidth]="2.5"></app-icon>
          </div>
          <div class="small lh-sm ps-0 pe-3">
            <small class="text-muted text-uppercase fw-bold">Cotización</small>
            <h2 class="small fw-bold text-primary text-uppercase mb-0">No. <span>{{quoteId || '-----'}}</span></h2>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg me-auto col-md-6 order-md-1">
        <div
          class="step-by-step px-2 bg-white overflow-hidden rounded-pill hstack shadow-sm position-relative d-flex align-content-center justify-content-center"
          style="min-height: 58px;">
          <ul
            class="d-flex small flex-row gap-4 hstack justify-content-center align-items-center m-0 p-0 list-unstyled">
            @for (step of steps; track step; let index = $index) {
            <li class="d-flex flex-column check-item gap-0 align-items-center justify-content-center"
              [ngClass]="{ 'check-active': isStepCompleted(index) }" style="min-width: 90px;">
              <app-icon class="bg-white position-relative z-1 border-3 border-white border-end border-start"
                [ngClass]="{ 'check-active': isStepCompleted(index) }"
                [name]="isStepCompleted(index) ? 'circle-check-big' : 'circle'" [size]="30" [strokeWidth]="3">
              </app-icon>
              <small>{{ step.label }}</small>
            </li>
            }
          </ul>
          <hr class="position-absolute border-2 top-0 start-0 end-0 bottom-0 mx-auto" style="
                            border-style: dashed;
                            pointer-events: none;
                            height: fit-content;
                            margin: auto;
                            margin-bottom: 36px;
                            z-index: 0;
                            width: 240px;">
        </div>
      </div>
    </div>
  </div>
</section>